import { parseISO } from 'date-fns';

export const parseDate = (date: string): Date => {
  const val = parseISO(date);

  return new Date(val.valueOf() + val.getTimezoneOffset() * 60 * 1000);
};
